import * as actions from './actions';

export default function(state = { editing: false, selection: {} }, action) {
  switch (action.type) {

  case actions.SET_EDITING:
    return {
      ...state,
      editing: action.editing
    };

  case actions.SET_ASSIGNEE:
    return {
      ...state,
      assignee: action.assignee
    };

  case actions.SET_DUE_DATE:
    return {
      ...state,
      dueDate: action.dueDate
    };

  case actions.SELECT_ALL:
    return {
      ...state,
      selection: action.allTaskIds.reduce((newState, id) => {
        newState[id] = true;
        return newState;
      }, {})
    };

  case actions.CLEAR_SELECTION:
    return {
      ...state,
      selection: {}
    };

  case actions.TOGGLE_TASK_SELECTION: {
    const newSelection = { ...state.selection };
    if (state.selection[action.task.id]) {
      delete newSelection[action.task.id];
    } else {
      newSelection[action.task.id] = true;
    }
    return {
      ...state,
      selection: newSelection
    };
  }

  default:
    return state;
  }
}